import { Routes, Route, Outlet, useLocation } from 'react-router-dom'

import SignUp from './view/SignUp'
import SignUpRegister from './view/SignUpRegister'
import SignUpPassword from './view/SignUpPassword'
import SignUpEmail from './view/SignUpEmail'
import SignUpForm from './view/SignUpForm'
import WaitingEmailVerification from './view/WaitingEmailVerification'
import WaitingHrTechVerification from './view/WaitingHrTechVerification'
import VerifyToken from './view/VerifyToken'
import SignUpTokenFail from './view/SignUpTokenFail'

const SignUpRoutes = () => {
  let location = useLocation()
  let state = location.state
  return (
    <>
      <Routes location={state?.backgroundLocation || location}>
        <Route index element={<SignUp />} />
        <Route path="/" element={<Outlet />}>
          <Route path="/invalid-signup" element={<SignUpTokenFail />} />
          <Route path="/register" element={<SignUpRegister />} />
          <Route path="/password" element={<SignUpPassword />} />
          <Route path="/form" element={<SignUpForm />} />
          <Route path="/waiting-email-verification" element={<WaitingEmailVerification />} />
          <Route path="/waiting-verification" element={<WaitingHrTechVerification />} />
          <Route path="/verify" element={<VerifyToken />} />
        </Route>
      </Routes>

      {state?.backgroundLocation && (
        <Routes>
          <Route path="/" element={<Outlet />}>
            <Route path=":email" element={<SignUpEmail />} />
          </Route>
        </Routes>
      )}
    </>
  )
}

export default SignUpRoutes
